import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
import store from '@/store';
import { Toast } from 'mint-ui'
import * as myCommon from '../global'
import { getuserToken, setuserToken, commonIp, isAndroid, isIos, isCheckUrl  } from '../global'
Vue.prototype.$http = axios


axios.defaults.headers.post['Content-Type']
  = 'application/x-www-form-urlencoded'

if (process.env.NODE_ENV === 'development') {
  // axios.defaults.baseURL = '/api'
  axios.defaults.baseURL = commonIp()
} else {
  axios.defaults.baseURL = commonIp()
}


  axios.interceptors.request.use(
    config => {
      let userToken = getuserToken(), appuserToken = ''
      appuserToken = localStorage.getItem('appuserToken');
      const { data, method, headers, params } = config
      let info, headerToken
      if (isAndroid() || isIos()) {

        info = { token: appuserToken }
        headerToken = appuserToken
      } else {
        if (data && data.noLogin) {
          info = {}
        } else if (data && data.token) {
          info = { token: data.token }
          headerToken = data.token
        } else {
          info = { token: userToken }
          headerToken = userToken
        }
      }

      if ('get' == method) {
        if(isCheckUrl(config.url,1)) {
          if (headerToken) {
            config.headers['token'] = headerToken
          }
        }
        config.params = Object.assign({}, {}, params);
        // config.params = Object.assign({}, info, params);
      } else if ('post' == method) {
        const params = Object.assign({}, data, info)
        let _headers = Object.assign({
          'Content-Type': 'application/json;charset=UTF-8'
        }, headers);
        if (_headers['Content-Type'].indexOf('application/x-www-form-urlencoded') != -1) {
          config.data = qs.stringfy(params)
        } else if (_headers['Content-Type'].indexOf('application/json') != -1) {
          config.data = params;
        }
      }
      return config
    },
    error => {
      Promise.reject(error)
    }
  )



// 响应拦截器
// var responseInt = axios.interceptors.response.use(
//   response => {
//     if (response && response.data.code !== 200) {
//       const err = {
//         status: response.data.code,
//         msg: response.data.message
//       }
//       if (response.data.code == 424 || response.data.code == 423) {

//         // 跳转到登陆
//         if (isAndroid() || isIos()) {
//           if (!appuserToken) {
//             window.location.href = 'app://login'
//           }
//         } else {
//           setuserToken('');
//           window.location.href = `${commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
//         }
//       } else {
//         if (response.data.code != 451) {
//           Toast(err.msg)
//         }
//       }
//       // 需要catch才能拿到错误信息
//       return Promise.reject(err)
//     } else {
//       return response
//     }
//   },
//   error => Promise.reject(error)
// )


  axios.interceptors.response.use(
    response => {
      let userToken = getuserToken(), appuserToken = ''
      appuserToken = localStorage.getItem('appuserToken');
      if(isCheckUrl(response.config.url)) {
        if (response && response.data.code !== 200) {
          const err = {
            status: response.data.code,
            msg: response.data.message
          }
          if (response.data.code == 424 || response.data.code == 423) {

            // 跳转到登陆
            if (isAndroid() || isIos()) {
              if (!appuserToken) {
                window.location.href = 'app://login'
              }
            } else {
              setuserToken('');
              window.location.href = `${commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
            }
          } else {
            if (response.data.code != 451 && response.data.code!= 411) {
              Toast(err.msg)
            }
          }
          // 需要catch才能拿到错误信息
          return Promise.reject(err)
        } else {
          return response
        }
      }else{
        return response
      }
    },
    error => Promise.reject(error)
  )



// if(isAndroid() || isIos()) {
//   if(!appuserToken) {
//     window.location.href = 'app://login'
//   }
// }else{
//   if(!userToken) {
//     axios.post(`${commonIp()}/v1/mobile/community/userInfo`)
//         .then((res) => {
//           setuserToken(res.data.data.token)
//           // setuserToken('J2FKuUPBuMnZpNpd1Uk1fkOlUdFdnNUN')
//         }).catch((error) => {
//             if(error.status == '424'||error.status == '423') {
//               // window.location.href = `${commonIp()}/quickLogin?referer=${encodeURIComponent(window.location.href)}`;
//             }else{
//               Toast(error.msg)
//             }
//         })
//   }
// }



export default axios



// WEBPACK FOOTER //
// ./src/axios/index.js